import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-json',
    imports: [MatDialogModule, CommonModule],
    templateUrl: './dialog-json.component.html',
    styleUrls: ['./dialog-json.component.css'],
})
export class DialogJson {

    parsed: any;

    constructor(
        public dialogRef: MatDialogRef<DialogJson>,
        @Inject(MAT_DIALOG_DATA) public data: { organisationName: string; valuesJson: string }
    ) {
        try {
            this.parsed = JSON.parse(data.valuesJson);
        } catch {
            this.parsed = data.valuesJson;
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
